import React, { Component } from 'react';

const lightsConfig = [
  { color: '#28a745', key: 'green' },
  { color: '#fd7e14', key: 'orange' },
  { color: '#dc3545', key: 'red' },
];

const semaphoreStyles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    backgroundColor: 'rgba(0,0,0,0.3)',
    zIndex: 2000,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    paddingTop: '15vh',
    animation: 'fadeInOverlaySemaphore 0.3s ease-out',
  },
  modal: {
    background: 'rgb(255, 255, 255)',
    border: '1px solid rgba(255,255,255,0.3)',
    backdropFilter: 'blur(8px)',
    borderRadius: '16px',
    padding: '2rem 3.5rem',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    animation: 'popUpModalSemaphore 0.3s ease-out',
    boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
  },
  semaphoreContainer: { display: 'flex', gap: '12px', marginBottom: '1.5rem' },
  light: {
    width: '20px',
    height: '20px',
    borderRadius: '50%',
    border: '2px solid rgba(0,0,0,0.08)',
    transition: 'opacity 0.4s ease-in-out, transform 0.4s ease-in-out',
  },
  message: {
    marginTop: '1rem',
    color: 'rgb(50, 50, 50)',
    fontSize: '1.4rem',
    textAlign: 'center',
    maxWidth: '300px',
    lineHeight: '1.4',
  },
};

class SemaphoreLoading extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeIndex: 0,
    };
    this.intervalId = null;
  }

  componentDidMount() {
    this.intervalId = setInterval(() => {
      this.setState(prev => ({ activeIndex: (prev.activeIndex + 1) % 3 }));
    }, 3000);
  }

  componentWillUnmount() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  render() {
    const { show, message } = this.props;
    if (!show) return null;

    return (
      <div style={semaphoreStyles.overlay}>
        <div style={semaphoreStyles.modal}>
          <div style={semaphoreStyles.semaphoreContainer}>
            {lightsConfig.map((light, index) => (
              <div
                key={light.key}
                style={{
                  ...semaphoreStyles.light,
                  backgroundColor: light.color,
                  opacity: index === this.state.activeIndex ? 1 : 0.25,
                  transform: index === this.state.activeIndex ? 'scale(1.12)' : 'scale(1)',
                  animation: index === this.state.activeIndex ? 'pulseSemaphore 1.5s infinite alternate' : 'none',
                }}
              />
            ))}
          </div>
          <div style={semaphoreStyles.message} dangerouslySetInnerHTML={{ __html: message }} />
        </div>
        <style>{`
          @keyframes popUpModalSemaphore { 
            0% { transform: translateY(-25px) scale(0.9); opacity: 0; } 
            100% { transform: translateY(0) scale(1); opacity: 1; } 
          }
          @keyframes fadeInOverlaySemaphore { 
            from { opacity: 0; } 
            to { opacity: 1; } 
          }
          @keyframes pulseSemaphore {
            0% { opacity: 1; transform: scale(1.12); }
            50% { opacity: 0.6; transform: scale(1.05); }
            100% { opacity: 1; transform: scale(1.12); }
          }
        `}</style>
      </div>
    );
  }
}

export default SemaphoreLoading;
